import { DatastoreProvider, InstanceDashboard } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { type RoutePath, useLocalSearchParams } from 'expo-router';

const moduleFn = () => import('feature/ranking-eval/ranking-eval-module');

export default function RankingEvalDashboardLayout() {
    const { siloKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/ranking-eval/one`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'ranking-eval',
        instanceKey: 'one',
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceDashboard />
        </DatastoreProvider>
    );
}
